import React, { useEffect } from "react";
import { OrderedListOutlined, BorderOutlined, CheckSquareOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Table, DatePicker, Form, Select } from "antd";
import { useModel } from "../../../models";
import { DICT_KEY, getDictNameByCode } from "../../../utils/constants";

const OPT_TYPE = {
    ADD: 1,
    REMOVE: 2
}

export default function () {
    const [form] = Form.useForm();

    const [
        {
            addMaterialModelVisible, materialList, materialPageInfo,
            materialSearchParam, selectedMaterialList, formData, documentMaterialList
        },
        {
            setAddMaterialModelVisible, loadPurchaseDetailData, loadPurchaseDetailDataAll,
            transSelectedPoItemListToRoItemList, addSelectedMaterial,
            setSelectedMaterialList, removeSelectedMaterial
        }
    ] = useModel("purchaseRo");
    const { pageSize, } = materialPageInfo;
    const { supplierId } = formData;
    const supplierName = getDictNameByCode(DICT_KEY.CM_DICT.SUPPLIER, supplierId);

    useEffect(() => {
        setSelectedMaterialList([]);
        if (addMaterialModelVisible && supplierId) {
            loadPurchaseDetailData({
                showMsg: false,
                data: {
                    supplierId,
                    supplierName,
                    pageNum: 1,
                    pageSize
                }
            });
        }
    }, [addMaterialModelVisible]);
    const onOk = async () => {
        //将已选采购明细添加到退货明细里
        transSelectedPoItemListToRoItemList();
        setSelectedMaterialList([]);
        //关闭窗口
        setAddMaterialModelVisible(false);
    }
    const onClose = () => {
        setAddMaterialModelVisible(false);
    }
    const onSearch = () => {
        const searchParam = form.getFieldsValue();
        const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
        const { purchaseCode, materialCodeOrName } = searchParam;
        loadPurchaseDetailData({
            showMsg: false,
            data: {
                supplierId,
                supplierName,
                pageSize,
                pageNum: 1,
                purchaseCode,
                materialCodeOrName,
                startTime,
                endTime
            }
        });
    }

    //全选
    const onCheckAll = () => {
        const searchParam = form.getFieldsValue();
        const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
        const { purchaseCode, materialCodeOrName } = searchParam;
        loadPurchaseDetailDataAll({
            showMsg: false,
            data: {
                supplierId,
                supplierName,
                pageSize: 999999,
                pageNum: 1,
                purchaseCode,
                materialCodeOrName,
                startTime,
                endTime
            }
        });
    }

    const onAdd = (record) => {
        addSelectedMaterial(record);
    }
    const onRemove = (record) => {
        removeSelectedMaterial(record);
    }
    const Title = () => {
        return (

            <h3 style={{ flex: "1" }}>
                <OrderedListOutlined />
                <span className="margin-left-8">采购退货单-选择配件</span>
            </h3>

        )
    }
    const columns = (optType) => [
        {
            title: '序号',
            dataIndex: 'code',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        {
            title: '采购单号',
            width: 160,
            dataIndex: 'purchaseCode',
            align: 'left',
        },
        {
            title: '制单日期',
            width: 100,
            dataIndex: 'createTime',
            align: 'left',
            render: text => text.split(" ")[0]
        },
        {
            title: '供应商',
            width: 180,
            dataIndex: 'supplierName',
            render: () => (!!supplierName) ? supplierName : ""
        },
        {
            title: '商品编码',
            width: 140,
            dataIndex: 'materialCode',
            align: 'left',
        },
        {
            title: '商品名称',
            width: 280,
            dataIndex: 'materialName',
            align: 'left',
        },
        {
            title: '图号',
            width: 120,
            dataIndex: 'replaceNum',
        },

        {
            title: '单位',
            width: 80,
            dataIndex: 'materialUnitName',
        },
        {
            title: '采购数量',
            width: 80,
            dataIndex: 'purchaseNum',
        },
        {
            title: '赠品数量',
            width: 80,
            dataIndex: 'giftsNum',
            align: 'left',
        },
        {
            title: '已退数量',
            width: 80,
            dataIndex: 'returnNum',
        },
        {
            title: '业务员',
            width: 100,
            dataIndex: 'createUser',
        },
        {
            title: '操作',
            width: 60,
            fixed: 'right',
            render: (text, record) => (
                optType === OPT_TYPE.ADD ? (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    disabled={
                        !!selectedMaterialList.find(el => el.id === record.id)
                        || !!documentMaterialList.find(el => !!el.porderId && el.porderId === record.id)
                        || record.purchaseNum <= record.returnNum
                    }
                    onClick={() => onAdd(record)}
                >
                    添加
                </Button>) : (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    onClick={() => onRemove(record)}
                >
                    移除
                </Button>)
            ),
        },
    ];
    const StockMaterialList = () => {
        return (
            <>
                <div style={{ margin: "0 0 8px", display: "flex" }}>
                    <h3 style={{ width: "500px", paddingTop: "6px" }}>
                        <BorderOutlined /> 待选配件列表
                    </h3>
                    <div className="detail-list-statistic">
                        <Form form={form} name="purchase_item_search_form" layout="inline" onFinish={onSearch}>
                            <Form.Item
                                name="purchaseCode"
                            >
                                <Input
                                    placeholder="采购单号"
                                />
                            </Form.Item>
                            <Form.Item
                                name="materialCodeOrName"
                            >
                                <Input
                                    placeholder="请输入商品编号或商品名称"
                                />
                            </Form.Item>
                            <Form.Item
                                name="startEndTime"
                            >
                                <DatePicker.RangePicker placeholder="起止" />
                            </Form.Item>
                            <Form.Item shouldUpdate={true}>
                                <Button htmlType="submit" type="primary">查询</Button>
                                <Button type="checkAll" style={{ marginLeft: "5px" }} onClick={onCheckAll}>全选</Button>
                            </Form.Item>
                        </Form>
                    </div>

                </div>
                <Table
                    columns={columns(OPT_TYPE.ADD)}
                    dataSource={materialList}
                    bordered
                    pagination={{
                        // simple: true,
                        hideOnSinglePage: false,
                        showQuickJumper: true,
                        defaultCurrent: 1,
                        defaultPageSize: pageSize,
                        onChange: (pageNum, pageSize) => {
                            const searchParam = form.getFieldsValue();
                            const [startTime = null, endTime = null] = !!searchParam["startEndTime"] ? searchParam["startEndTime"] : [];
                            const { purchaseCode, materialCodeOrName } = searchParam;
                            loadPurchaseDetailData({
                                showMsg: false,
                                data: {
                                    supplierId,
                                    supplierName,
                                    pageSize,
                                    pageNum,
                                    purchaseCode,
                                    materialCodeOrName,
                                    startTime,
                                    endTime
                                }
                            });
                            /*const params = {
                                ...materialSearchParam,
                                pageNum, pageSize,
                                supplierId,
                                supplierName,
                            };
                            loadPurchaseDetailData({showMsg: false, data: params});*/
                        },
                        total: materialPageInfo.total,
                        current: materialPageInfo.pageNum,
                    }}
                    scroll={{ y: 220, x: 1900 }}
                />
            </>
        )
    }
    const SelectedStockMaterialList = () => {
        return (
            <>
                <div style={{ margin: "8px 0", display: "flex" }}>
                    <h3 style={{ width: "460px", paddingTop: "6px" }}>
                        <CheckSquareOutlined /> 已选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{ textAlign: "right" }}>

                    </div>
                </div>
                <Table
                    scroll={{ y: 200, x: 1300 }}
                    columns={columns(OPT_TYPE.REMOVE)}
                    dataSource={selectedMaterialList}
                    bordered
                    pagination={false}
                />
            </>
        )
    }
    return (
        <Modal
            title={<Title />}
            width={1366}
            visible={addMaterialModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            <StockMaterialList />
            <SelectedStockMaterialList />
        </Modal>
    );
}